module.exports = __webpack_public_path__ + "static/media/plier-one.0fd4e486.png";